export default __webpack_public_path__ + "static/Yard-Waste-Removal-beeb28309b5d0a55126e0df2f5b9ca03.jpg";